import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { AddUsedCardsStat, AppAuthService, SalesPointsService, UsedCardsStatsService } from '@prodcard/core'
import UsedCardsStatForm from './UsedCardsStatForm.vue'
import { createCtx, handleError } from '../../../../helpers'
import { CardHeader } from '../../../../components'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsedCardsStatNewPage',
  props: {
    salesPointsService: {},
    usedCardsStatsService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;


const router = useRouter()
const loading = ref(false)

const submit = (opts: AddUsedCardsStat) => {
  handleError(async () => {
    await props.usedCardsStatsService.add(createCtx(), opts)
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode("Внесение данных")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(UsedCardsStatForm, {
            salesPointsService: _ctx.salesPointsService,
            "auth-service": _ctx.authService,
            loading: loading.value,
            onOnSubmit: submit
          }, null, 8, ["salesPointsService", "auth-service", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})